import { render, staticRenderFns } from "./CreateCustomerUpload.vue?vue&type=template&id=0846c386&scoped=true&"
import script from "./CreateCustomerUpload.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0846c386",
  null
  
)

export default component.exports